 angular
     .module('vppApp')
     .factory('FindDealerResultsService', function() {

         var savedData = {
             mapInit: {
                 // zip: '12065',
                 range: 25
             },
             dealerResultsVO: [
                 {
                     addressType: "physical",
                     agreementTypeCode: "",
                     city: "CLIFTON PARK",
                     cityRegion: "",
                     confidenceRating: "100.0",
                     contactEmail: null,
                     contactName: "NORTHSTAR CHEVROLET, INC.",
                     contactType: null,
                     country: "US",
                     directions: null,
                     directionsUrl: "http://maps.google.com/?saddr=&daddr=42.85857 -73.77568",
                     distance: "9.4923",
                     distanceUnitOfMeasure: "mi",
                     image: null,
                     latitude: "42.85857",
                     longitude: "-73.77568",
                     makeCode: "",
                     mapUrl: "https://maps.googleapis.com/maps/api/staticmap?center=CLIFTON PARK NY&zoom=9&size=210x210&maptype=roadmap&markers=color:blue%7Clabel:S%7C42.85857 -73.77568&sensor=false",
                     patnerID: null,
                     phone: [
                         {
                             number: "5183715400",
                             type: "dealerMain"
                         }, {
                             number: "5183717464",
                             type: "dealerFax"
                         }
                    ],
                     postalCode: "120654035",
                     primaryName: "NORTHSTAR CHEVROLET, INC.",
                     regionCode: "NY",
                     responseValue: null,
                     sellingSourceCode: "13",
                     siteID: 292993,
                     street: [
                         {
                             streetLine: "1",
                             streetValue: "400 CLIFTON PARK CENTER ROAD"
                         }
                    ],
                     tplEligible: false,
                     urlSource: "PowerShift",
                     urlType: "DealerWebsite",
                     urlValue: "http://www.northstarchevrolet.net",
                     vehicleTypeCode: "",
                     vendorCode: "22034",
                     vendorId: "171827",
                     vendorType: "dealer"
                 }
             ]
             /*dealerResultsVO: [
                 {
                     "responseValue": {},
                     "vendorId": "string",
                     "sellingSourceCode": "string",
                     "primaryName": "string",
                     "directions": "string",
                     "vendorCode": "string",
                     "mapUrl": "string",
                     "directionsUrl": "string",
                     "patnerID": "string",
                     "vendorType": "string",
                     "confidenceRating": "string",
                     "distance": "string",
                     "distanceUnitOfMeasure": "string",
                     "image": "string",
                     "makeCode": "string",
                     "agreementTypeCode": "string",
                     "vehicleTypeCode": "string",
                     "urlValue": "string",
                     "urlSource": "string",
                     "urlType": "string",
                     "contactName": "string",
                     "street": [
                         {
                             "streetValue": "string",
                             "streetLine": "string"
                         }
                     ],
                     "city": "string",
                     "cityRegion": "string",
                     "regionCode": "string",
                     "postalCode": "string",
                     "country": "string",
                     "latitude": "string",
                     "longitude": "string",
                     "addressType": "string",
                     "contactEmail": "string",
                     "phone": [
                         {
                             "number": "string",
                             "type": "string"
                         }
                     ],
                     "contactType": "string",
                     "siteID": 0,
                     "tplEligible": false
                 }, {
                     "responseValue": {},
                     "vendorId": "string",
                     "sellingSourceCode": "string",
                     "primaryName": "string",
                     "directions": "string",
                     "vendorCode": "string",
                     "mapUrl": "string",
                     "directionsUrl": "string",
                     "patnerID": "string",
                     "vendorType": "string",
                     "confidenceRating": "string",
                     "distance": "string",
                     "distanceUnitOfMeasure": "string",
                     "image": "string",
                     "makeCode": "string",
                     "agreementTypeCode": "string",
                     "vehicleTypeCode": "string",
                     "urlValue": "string",
                     "urlSource": "string",
                     "urlType": "string",
                     "contactName": "string",
                     "street": [
                         {
                             "streetValue": "string",
                             "streetLine": "string"
                         }
                     ],
                     "city": "string",
                     "cityRegion": "string",
                     "regionCode": "string",
                     "postalCode": "string",
                     "country": "string",
                     "latitude": "string",
                     "longitude": "string",
                     "addressType": "string",
                     "contactEmail": "string",
                     "phone": [
                         {
                             "number": "string",
                             "type": "string"
                         }
                     ],
                     "contactType": "string",
                     "siteID": 0,
                     "tplEligible": false
                 }
             ]*/
         };

         function set(data) {
             savedData = data;
         }
         function get() {
             return savedData;
         }

         // var FindDealerResultsService = {
         //
         // };

         return {
             set: set,
             get: get
         };

     });
